module.exports = __webpack_public_path__ + "static/reel-cam-65d8dd976062db13f2804b60a98101f7.mp4";